<zci-interstitial-page-content [backLink]="appRoutes.OWN_ACCOUNTS"></zci-interstitial-page-content>
